import service from '@/request/config/axios'

import ApiPrefix from '@/request/config/prefix'

/** auth服务 */
const authService = {
  getSystemInfo: () =>
    service(`${ApiPrefix.ADMIN}/admin/system`, {
      method: 'get',
      headers: {
        withCredentials: true,
      },
      showToast: false,
    }),
}

export default authService
